/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Removeimageindicator from 'material/embeds/removeimageindicator/removeimageindicator';
import Background from 'material/embeds/content/shared/background/background_container';
import PartnerLogo from 'material/embeds/content/shared/logo/partner/partner_container';
import StoryTitle from 'material/embeds/content/shared/storytitle/storytitle_container';
import StoryCTA from 'material/embeds/content/shared/storycta/storycta_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/contenttype/story/story_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : STORY ~~~~~~~~~~ ========== */
class Story extends Component {
    handleImageRemoval = () => {
        this.props.removeBackgroundImage(this.props.contentId)
    };
    render() {
        return(
            <div className={`uniquecontent story ${this.props.classes.story}`}>
                <div className={`structure header`}>
                    <div className={`structureinner`}>
                        <PartnerLogo />
                    </div>
                </div>
                <div className={`structure body`}>
                    <div className={`structureinner`}>
                        <StoryTitle contentId={this.props.contentId} isEditable={this.props.isEditable}/>
                        <StoryCTA contentId={this.props.contentId} isEditable={this.props.isEditable}/>
                    </div>
                </div>
                <Background
                    isSelected={this.props.isSelected}
                    backgroundImageURL={this.props.backgroundImageURL}
                    currentBackgroundImage={this.props.currentBackgroundImage}
                    previewBackgroundImageURL={this.props.previewBackgroundImageURL}
                    backgroundColor={this.props.backgroundColor}
                    contentId={this.props.contentId}
                    isEditable={this.props.isEditable} />
                    {this.props.isEditable && <Removeimageindicator handleRemoval={this.handleImageRemoval}/>}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Story);
